<template>
  <div v-if="isLoading" class="loading-panel">
    <span>Loading</span>
    <i class="fas fa-spinner"></i>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-panel {
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
  background-image: url("https://images.unsplash.com/photo-1551776235-dde6d482980b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80");
  text-align: center;
  font-size: var(--fs-xxl);
  font-weight: bold;
  padding: var(--g-xxl);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  i {
    animation: spin 1.5s infinite linear;
  }
  span {
    margin-right: var(--g-xl);
    display: block;
    animation: ro 1.5s infinite;
  }
}
@keyframes ro {
  0% {
    transform: rotateX(0deg);
  }
  100% {
    transform: rotateX(360deg);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>